export const SOCIAL_LINKS = {
  github: { url: 'https://github.com/mavengence', label: 'GitHub' },
  linkedin: { url: 'https://www.linkedin.com/in/tim-loehr-821ba8188/', label: 'LinkedIn' },
  medium: { url: 'https://medium.com/@mavengence', label: 'Medium' },
  scholar: { url: 'https://scholar.google.com/citations?user=DLV7IqAAAAAJ&hl=en', label: 'Google Scholar' },
  email: { url: 'mailto:timloehr@outlook.de', label: 'Email' },
};
